var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "component-productList"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showTitle,
      expression: "showTitle"
    }],
    staticClass: "hot-list-title"
  }, [_vm._v("热门商品")]), _vm._l(_vm.productList, function (item, index) {
    return item.goodsId ? _c('div', {
      key: index,
      staticClass: "product-item J_Report",
      attrs: {
        "id": 'goods_' + item.goodsId,
        "data-item_id": item.goodsId,
        "data-product_category": "product"
      },
      on: {
        "click": function click($event) {
          $event.stopPropagation();
          return _vm.toProductAddress(item);
        }
      }
    }, [_c('normalItem', {
      attrs: {
        "item": item,
        "in-preview": _vm.inPreview
      }
    })], 1) : _vm._e();
  })], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };